import React from 'react';
import { motion } from 'framer-motion';
export function FlyWithUs() {
  return <div className="pt-32 pb-24 min-h-screen bg-white" data-id="element-262">
      <div className="max-w-7xl mx-auto px-6" data-id="element-263">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-264">
          <h1 className="text-5xl font-serif text-charcoal-900 mb-6" data-id="element-265">
            Fly With Us
          </h1>
          <p className="text-xl text-gray-600" data-id="element-266">
            Experience the ultimate freedom of private charter. Access thousands
            of airports worldwide on your schedule.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-267">
          {[{
          title: 'Light Jets',
          desc: 'Perfect for short regional trips. Seats up to 7 passengers comfortably.',
          img: 'https://images.unsplash.com/photo-1583416750470-965b2707b355?q=80&w=600&auto=format&fit=crop'
        }, {
          title: 'Midsize Jets',
          desc: 'Ideal for cross-country travel with enhanced cabin space and amenities.',
          img: 'https://images.unsplash.com/photo-1540962351504-03099e0a754b?q=80&w=600&auto=format&fit=crop'
        }, {
          title: 'Heavy Jets',
          desc: 'The pinnacle of luxury for intercontinental flights. Seats up to 16.',
          img: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?q=80&w=600&auto=format&fit=crop'
        }].map((fleet, i) => <motion.div key={fleet.title} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-50 rounded-2xl overflow-hidden" data-id="element-268">
              <img src={fleet.img} alt={fleet.title} className="w-full h-48 object-cover" data-id="element-269" />
              <div className="p-6" data-id="element-270">
                <h3 className="text-2xl font-serif text-charcoal-900 mb-2" data-id="element-271">
                  {fleet.title}
                </h3>
                <p className="text-gray-600" data-id="element-272">{fleet.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </div>;
}